function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  opacity: ".4",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.25 3a.75.75 0 01.75-.75h4a.75.75 0 01.75.75v4a.75.75 0 01-1.5 0V3.75H17a.75.75 0 01-.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.53 2.47a.75.75 0 010 1.06l-6 6a.75.75 0 11-1.06-1.06l6-6a.75.75 0 011.06 0zM3 16.25a.75.75 0 01.75.75v3.25H7a.75.75 0 010 1.5H3a.75.75 0 01-.75-.75v-4a.75.75 0 01.75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.53 14.47a.75.75 0 010 1.06l-6 6a.75.75 0 01-1.06-1.06l6-6a.75.75 0 011.06 0z"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.25 12C1.25 6.066 6.066 1.25 12 1.25c.74 0 1.47.075 2.167.215a.75.75 0 11-.294 1.47A9.577 9.577 0 0012 2.75c-5.106 0-9.25 4.144-9.25 9.25 0 .64.065 1.26.185 1.85a.75.75 0 01-1.47.3A10.8 10.8 0 011.25 12zm20.403-2.735a.75.75 0 01.882.588c.14.696.215 1.416.215 2.147 0 5.934-4.816 10.75-10.75 10.75-.74 0-1.47-.075-2.167-.214a.75.75 0 01.294-1.471A9.61 9.61 0 0012 21.25c5.106 0 9.25-4.144 9.25-9.25a9.43 9.43 0 00-.186-1.853.75.75 0 01.589-.882z"
})));